<template>
  <div>
    <div id="map" class="w-100 min-vh-50 mb-4"></div>
    <div class="row">
      <div class="col-md-4 col-lg-3 mb-3 mb-md-0">
        <label>{{ dataTexts.filter_country }}</label>
        <select
          class="form-control"
          v-model="selectedCountry"
          @change="
            updateLocations();
            focus();
          "
        >
          <option :value="null">{{ dataTexts.filter_country_all }}</option>
          <option
            v-for="(country, index) in dataCountries"
            :key="index"
            :value="index"
          >
            {{ country }}
          </option>
        </select>
      </div>
      <div class="col-md-4 col-lg-3">
        <label>{{ dataTexts.filter_type }}</label>
        <select
          class="form-control"
          v-model="selectedType"
          v-on:change="updateLocations()"
        >
          <option :value="null">{{ dataTexts.filter_type_all }}</option>
          <option v-for="type in dataTypes" :key="type">{{ type }}</option>
        </select>
      </div>
      <div
        v-if="
          selectedType || selectedCountry || locationIds.length < markers.length
        "
        class="col-md-3 align-self-end"
      >
        <button
          class="btn btn-small px-0"
          v-on:click="
            selectedType = null;
            selectedCountry = null;
            updateLocations();
            focus();
          "
        >
          <i class="icon-refresh"></i> {{ dataTexts.reset }}
        </button>
      </div>
    </div>

    <transition-group name="fade" class="row mt-3">
      <div
        v-for="location in locations"
        :key="location.id"
        class="col-md-4 col-lg-3 mb-3"
      >
        <div class="p-3 bg-white shadow small rounded" v-html="location.infoHtml"></div>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  props: ["dataTexts", "dataLocations", "dataTypes", "dataCountries", "dataCountriesLatLng"],
  data() {
    return {
      locations: this.dataLocations,
      selectedCountry: null,
      selectedType: null,
      locationIds: [],
      markers: [],
      map: null,
      activeInfoWindow: null,
    };
  },
  mounted() {
    this.map = new google.maps.Map(document.getElementById("map"), {
      zoom: window.innerWidth > 480 ? 2 : 0,
      center: { lat: 25.358704, lng: 29.471082 },
      mapTypeId: "hybrid",
      clickableIcons: false,
    });
    this.setMarkers();
    const vue = this;
    this.map.addListener("center_changed", function () {
      vue.filterByMarkers();
    });
    this.map.addListener("zoom_changed", function () {
      vue.filterByMarkers();
    });
  },
  computed: {},
  methods: {
    updateLocations() {
      this.locations = this.dataLocations
        .filter((location) => {
          return this.selectedType
            ? location.type == this.selectedType
            : location;
        })
        .filter((location) => {
          return this.selectedCountry
            ? location.country == this.selectedCountry
            : location;
        });
      this.updateMarkers();
    },
    filterByMarkers() {
      this.locationIds = [];
      for (var i = 0; i < this.markers.length; i++) {
        if (this.map.getBounds().contains(this.markers[i].getPosition())) {
          this.locationIds.push(this.markers[i].id);
        }
      }
      this.locations = this.dataLocations.filter((location) => {
        return this.locationIds.includes(location.id);
      });
    },
    updateMarkers() {
      this.removeAllMarkers();
      this.setMarkers();
    },
    setMarkers() {
      const vue = this;
      this.locations.forEach((location, index) => {
        this.markers[index] = new google.maps.Marker(location);

        var infowindow = new google.maps.InfoWindow({
          content: location.infoHtml,
        });

        google.maps.event.addListener(
          this.markers[index],
          "click",
          function () {
            if (vue.activeInfoWindow) {
              vue.activeInfoWindow.close();
            }
            infowindow.open(vue.map, vue.markers[index]);
            vue.activeInfoWindow = infowindow;
            vue.map.setCenter(vue.markers[index].position);
            vue.map.setZoom(10);
          }
        );
        this.markers[index].setMap(this.map);
      });
    },
    removeAllMarkers() {
      for (var i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null);
      }
      this.markers = [];
    },
    focus() {
      if (this.selectedCountry) {
        var latLng = { lat: this.dataCountriesLatLng[this.selectedCountry][0], lng: this.dataCountriesLatLng[this.selectedCountry][1] }
        console.log(this.dataCountriesLatLng[this.selectedCountry])
        this.map.setCenter(latLng);
        if (this.dataCountriesLatLng[this.selectedCountry][2]) {
            this.map.setZoom(this.dataCountriesLatLng[this.selectedCountry][2]);
        } else {
            this.map.setZoom(4);
        }
      } else {
        this.map.setCenter({ lat: 25.358704, lng: 29.471082 });
        this.map.setZoom(window.innerWidth > 480 ? 2 : 0);
      }
    },
  },
};
</script>

